<template>
  <tw-custom-dialog transition="fadet"
                    width="600"
                    v-model="dialog">

    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
      </slot>
    </template>
    <template v-slot:title>
      Cadastro de cliente
    </template>
    <template>
      <v-row dense>
        <v-col cols="12" sm="12" md="12">
          <v-text-field outlined
                        hide-details
                        maxlength="255"
                        class="required"
                        label="Nome do Cliente"
                        :error="$v.clienteEdit.nome.$error"
                        @blur="$v.clienteEdit.nome.$touch()"
                        v-model="clienteEdit.nome"/>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <v-text-field outlined
                        hide-details
                        maxlength="255"
                        class="required"
                        label="E-mail"
                        :error="$v.clienteEdit.email.$error"
                        @blur="$v.clienteEdit.email.$touch()"
                        v-model="clienteEdit.email"/>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <v-text-field outlined
                        hide-details
                        class="required"
                        label="Celular"
                        v-mask="['(##) #####-####']"
                        :error="$v.clienteEdit.celular.$error"
                        @blur="$v.clienteEdit.celular.$touch()"
                        v-model="clienteEdit.celular"/>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <tw-color-picker
            label="Cor"
            class="required"
            v-model="clienteEdit.cor"/>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <tw-autocomplete-tags v-model="clienteEdit.tags"/>
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-btn color="primary"
             class="mr-2"
             :loading="loadingForm"
             :disabled="$v.$invalid"
             @click="save">
        Salvar
      </v-btn>
      <v-btn @click="close">Cancelar</v-btn>
    </template>

  </tw-custom-dialog>
</template>

<script>
import ClienteService from '@/api/cliente-service';
import { email, required } from 'vuelidate/lib/validators';
import AutocompleteTags from '@/modules/tag/AutocompleteTags.vue';
import _ from 'lodash';

function resetEdit() {
  return {
    nome: null,
    email: null,
    celular: null,
    cor: '#FF0606',
    tags: [],
  };
}

export default {
  props: {
    cliente: Object,
  },
  data() {
    return {
      dialog: false,
      clienteEdit: resetEdit(),
      loadingForm: false,
    };
  },
  watch: {
    dialog() {
      if (this.cliente) {
        this.clienteEdit = _.cloneDeep(this.cliente);
        this.clienteEdit.cor = this.clienteEdit.cor || '#FF0606';
      } else {
        this.clienteEdit = resetEdit();
      }
      this.$v.$reset();
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    save() {
      this.loadingForm = true;
      ClienteService.save(this.clienteEdit)
        .then(() => {
          this.close();
          this.$emit('update');
          this.$toast('Cliente salvo', { color: 'success' });
        })
        .finally(() => {
          this.loadingForm = false;
        });
    },
  },
  components: {
    twAutocompleteTags: AutocompleteTags,
  },
  validations: {
    clienteEdit: {
      nome: {
        required,
      },
      email: {
        email,
      },
      celular: {
        required,
      },
    },
  },
};
</script>
